import { SIMILARWEB_EXTENSION_ID } from "./extensionDetection";

const SIMILARWEB_EXTENSION_STORE_URL = `https://chrome.google.com/webstore/detail/similarweb-traffic-rank-w/${SIMILARWEB_EXTENSION_ID}`;

const UTM_CAMPAIGN_PARAM = "utm_campaign";

export const extensionPromotionSourceMap = {
    landOnPro: "Land_on_Pro",
    afterTrialHomePage: "After_trial_Home_page",
    sideBanner: "Side_banner",
} as const;

export type ExtensionPromotionSource = (typeof extensionPromotionSourceMap)[keyof typeof extensionPromotionSourceMap];

export const getSimilarwebExtensionStoreUrl = (source: ExtensionPromotionSource): string => {
    const storeUrl = new URL(SIMILARWEB_EXTENSION_STORE_URL);
    storeUrl.searchParams.set(UTM_CAMPAIGN_PARAM, source);

    return storeUrl.toString();
};
